import { render, staticRenderFns } from "./LessonExtendedInfo.vue?vue&type=template&id=69972f2e&scoped=true&"
import script from "./LessonExtendedInfo.vue?vue&type=script&lang=ts&"
export * from "./LessonExtendedInfo.vue?vue&type=script&lang=ts&"
import style0 from "./LessonExtendedInfo.vue?vue&type=style&index=0&id=69972f2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69972f2e",
  null
  
)

export default component.exports